<script>
  let { onAdd } = $props();
  let open = $state(false);

  // 5 picks fanning up-and-right from bottom-left.
  // Angles are measured from the +x axis, counterclockwise.
  // 0° = directly right, 90° = directly up. Fan: 0, 22.5, 45, 67.5, 90.
  const PICKS = [
    { kind: 'audience', label: 'Audience', icon: '◉', angle: 0 },
    { kind: 'step',     label: 'Step',     icon: '▢', angle: 22.5 },
    { kind: 'deal',     label: 'Offer',     icon: '◈', angle: 45 },
    { kind: 'chain',    label: 'Chain',    icon: '⚡', angle: 67.5 },
    { kind: 'arrow',    label: 'Arrow',    icon: '→', angle: 90 }
  ];

  const RADIUS = 110;

  function pickPos(angleDeg) {
    const rad = (angleDeg * Math.PI) / 180;
    return {
      x: Math.cos(rad) * RADIUS,
      y: -Math.sin(rad) * RADIUS // negative y = up in screen coords
    };
  }

  function handlePick(kind) {
    open = false;
    onAdd?.({ kind });
  }
</script>

<div class="add-root" class:open>
  {#each PICKS as p}
    {@const pos = pickPos(p.angle)}
    <button
      type="button"
      class="pick pick-{p.kind}"
      style:--tx="{pos.x}px"
      style:--ty="{pos.y}px"
      onclick={() => handlePick(p.kind)}
      title={p.label}
      tabindex={open ? 0 : -1}
    >
      <span class="pick-icon">{p.icon}</span>
      <span class="pick-label">{p.label}</span>
    </button>
  {/each}

  <button
    type="button"
    class="add-btn"
    class:rotated={open}
    onclick={() => open = !open}
    aria-label={open ? 'Close add menu' : 'Open add menu'}
  >
    +
  </button>
</div>

<style>
  .add-root {
    position: absolute;
    left: 24px;
    bottom: 24px;
    z-index: 30;
    pointer-events: none;
  }

  .add-btn {
    position: relative;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: linear-gradient(180deg, #d4af37, #b8941f);
    color: #0a0a0c;
    border: 1px solid rgba(212,175,55,0.7);
    font-size: 32px;
    line-height: 1;
    cursor: pointer;
    box-shadow:
      inset 0 1px 0 rgba(255,255,255,0.4),
      0 8px 24px rgba(212,175,55,0.35),
      0 0 0 1px rgba(0,0,0,0.4);
    transition: transform 0.25s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.2s ease;
    pointer-events: auto;
    padding: 0;
    margin: 0;
    z-index: 2;
  }
  .add-btn:hover {
    transform: scale(1.05);
    box-shadow:
      inset 0 1px 0 rgba(255,255,255,0.5),
      0 12px 32px rgba(212,175,55,0.5),
      0 0 0 1px rgba(0,0,0,0.4);
  }
  .add-btn.rotated {
    transform: rotate(45deg);
  }
  .add-btn.rotated:hover {
    transform: rotate(45deg) scale(1.05);
  }

  .pick {
    position: absolute;
    left: 32px; /* center on the + button (32 = half of 64) */
    bottom: 32px;
    width: 64px;
    height: 64px;
    margin-left: -32px;
    margin-bottom: -32px;
    border-radius: 50%;
    background: linear-gradient(145deg, #1c1c20, #0a0a0c);
    border: 1px solid rgba(212,175,55,0.35);
    color: #f0efe9;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    transform: translate(0, 0) scale(0.4);
    opacity: 0;
    pointer-events: none;
    transition:
      transform 0.32s cubic-bezier(0.16, 1, 0.3, 1),
      opacity 0.18s ease,
      background 0.15s ease,
      border-color 0.15s ease;
    box-shadow:
      inset 0 1px 0 rgba(255,255,255,0.06),
      0 6px 18px rgba(0,0,0,0.55);
    padding: 0;
  }
  .add-root.open .pick {
    transform: translate(var(--tx), var(--ty)) scale(1);
    opacity: 1;
    pointer-events: auto;
  }
  .pick:hover {
    background: linear-gradient(145deg, #232328, #101014);
    border-color: rgba(212,175,55,0.7);
  }
  .pick-icon {
    font-size: 18px;
    color: #d4af37;
    line-height: 1;
  }
  .pick-label {
    font-family: 'JetBrains Mono', monospace;
    font-size: 9px;
    letter-spacing: 0.8px;
    text-transform: uppercase;
    color: #c8c5bc;
  }
</style>
